<script>
	import { createEventDispatcher } from 'svelte'
	import { fly } from 'svelte/transition'
	import ListOperators from '../../Programs/ListOperators.svelte'
	import userStore from '../../../stores/user'

	const dispatch = createEventDispatcher()

	const onOperatorSelect = (event) => {
		dispatch('operator-select', event.detail)
		// console.log ('onOperatorSelect', event.detail)
	}
</script>

<div class="details-panel" in:fly={{ x: 40, duration: 150 }}>
	<i class="arrow fas fa-caret-left"></i>
	<ListOperators sectorId={$userStore.sector.id} height="150px" on:select={onOperatorSelect} on:app-event />
</div>

<style>
	.details-panel {
		/* background-color: #fdfbdd; */
		/* background-color: #fff; */
		background-color: #ecf2f6;
		position: absolute;
		/* padding: 10px; */
		width: 300px;
		min-height: 150px;
		right: -320px;
		bottom: 0;
	}
	.details-panel .arrow {
		position: absolute;
		bottom: 38px;
		left: -8px;
		width: 0px;
		height: 0px;
		/* color: #fdfbdd; */
		/* color: #fff; */
		color: #ecf2f6;
		font-size: 26px;
	}
</style>
